export default "__VITE_ASSET__167a6c32__"